// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"ChapterPlayer_Thumb__283bB","ThumbZoom":"ChapterPlayer_ThumbZoom__2aD-G"};